import React from "react";
import { fmtStatusTime, parseTimeInput } from "../../utils/timecard";

export default function TimeCell({ id, value, format, onChange, readOnly, ariaLabel }) {
  const [editing, setEditing] = React.useState(false);
  const [draft, setDraft] = React.useState("");
  const inputRef = React.useRef(null);

  React.useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  const commitEdit = () => {
    const trimmed = draft.trim();
    if (!trimmed) {
      if (value) onChange("");
    } else {
      const parsed = parseTimeInput(trimmed);
      if (parsed !== null) {
        onChange(parsed);
      }
    }
    setDraft("");
    setEditing(false);
  };

  if (readOnly) {
    return (
      <span id={id} className={`time-cell-display time-cell-readonly${!value ? " time-cell-empty" : ""}`}>
        {value ? fmtStatusTime(value, format) : "--:--"}
      </span>
    );
  }

  if (value && !editing) {
    return (
      <button
        type="button"
        id={id}
        className="time-cell-display"
        onClick={() => {
          setDraft(fmtStatusTime(value, format));
          setEditing(true);
        }}
        aria-label={ariaLabel}
      >
        {fmtStatusTime(value, format)}
      </button>
    );
  }

  return (
    <input
      ref={inputRef}
      id={id}
      type="text"
      value={draft}
      placeholder={format === "12h" ? "--:-- AM" : "--:--"}
      aria-label={ariaLabel}
      onChange={(e) => {
          let val = e.target.value;
          if (format === "12h") {
            // Keep digits, colon, space, and A/P/M; uppercase the letters
            val = val.replace(/[^\d:\sAPMapm]/g, "").replace(/[apm]/g, c => c.toUpperCase());
            // Auto-complete A → AM, P → PM; dedup in case user also typed M manually
            if (/[AP]$/.test(val)) val += "M";
            val = val.replace(/(AM|PM)M+$/, "$1");
          } else {
            val = val.replace(/[^\d:]/g, "");
          }
          // Auto-insert colon after 2 digits: "083" → "08:3"
          if (/^\d{3}$/.test(val)) {
            val = val.slice(0, 2) + ":" + val.slice(2);
          }
          setDraft(val);
        }}
      onBlur={commitEdit}
      onKeyDown={(e) => {
        if (e.key === "Enter") commitEdit();
        if (e.key === "Escape") {
          setDraft("");
          setEditing(false);
        }
      }}
    />
  );
}
